<template>
  <div>
    <header class="grid w-full grid-cols-3 py-5 border-b border-sc-gray-light bg-sc-beige-light">
      <div class="flex flex-col col-span-2 col-start-1 px-5 text-base text-left md:justify-start md:flex-row md:text-xl text-sc-gray-dark">
        <p class="self-center max-w-xs truncate">
          {{ holderName || description }}
        </p>
        <div class="flex px-6">
          <p>
            {{ formattedValue }}
          </p>
          <img
            v-if="isIncome"
            :src="require('@assets/images/green_arrow.svg')"
            class="self-center h-4 p-1 ml-1 transform rotate-180 rounded-sm bg-approved"
            alt="flecha para abajo"
          >
          <img
            v-else
            :src="require('@assets/images/red_arrow.svg')"
            class="self-center h-4 p-1 ml-1 transform rotate-180 rounded-sm bg-rejected"
            alt="flecha para arriba"
          >
        </div>
      </div>
      <div class="flex self-center justify-center col-span-1 col-start-3 text-right md:justify-end md:px-5">
        <span
          class="self-center px-2 py-1 text-sm rounded cursor-pointer md:mx-3 text-primary"
          :class="currentCheck ? ['bg-approved', 'text-approved'] : ['bg-pending', 'text-pending']"
        >
          {{ translateStatus[currentStatus] }}
        </span>

        <button
          @click="hide()"
        >
          <img
            :src="require('@assets/images/cross.svg')"
            class="self-center h-5 p-1 ml-1"
            alt="cerrar"
          >
        </button>
      </div>
    </header>
    <div
      class="grid w-full grid-cols-2 px-4 border-b md:grid-cols-3 border-sc-gray-light"
    >
      <div
        class="grid w-full h-full grid-cols-1 pt-2 pb-3 border-r md:grid-cols-2 md:col-span-2 md:col-start-1 md:grid-rows-5 border-sc-gray-light"
        ref="defaultColumnsGrid"
      >
        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.postDate') }}
          </b>
          <p class="text-sm text-sc-gray">
            {{ postDate | date(utc=true) }}
          </p>
        </div>
        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.transactionDate') }}
          </b>
          <p
            class="text-sm text-sc-gray"
            v-if="transactionDate"
          >
            {{ transactionDate | dateTime(utc=true) }} hrs
          </p>
          <p
            class="text-sm text-sc-gray"
            v-else
          >
            -
          </p>
        </div>

        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.senderInfo') }}
          </b>
          <p class="text-sm text-sc-gray">
            {{ senderInfo ||'-' }}
          </p>
        </div>

        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.holderRut') }}
          </b>
          <p
            class="text-sm text-sc-gray"
            v-if="holderRut"
          >
            {{ holderRut | rutFilter }}
          </p>
          <p
            class="text-sm text-sc-gray"
            v-else
          >
            -
          </p>
        </div>

        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.movementId') }}
          </b>
          <p class="text-sm text-sc-gray">
            {{ movementId }}
          </p>
        </div>
        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.typeName') }}
          </b>
          <p class="text-sm text-sc-gray">
            {{ typeName }}
          </p>
        </div>
        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.description') }}
          </b>
          <p class="text-sm text-sc-gray">
            {{ description }}
          </p>
        </div>
        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.referenceId') }}
          </b>
          <p class="text-sm break-all text-sc-gray">
            {{ referenceId || '-' }}
          </p>
        </div>
        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.comment') }}
          </b>
          <p class="text-sm break-words text-sc-gray">
            {{ comment || '-' }}
          </p>
        </div>

        <div
          class="p-2 ml-3 ellipsis"
        >
          <b class="text-xs uppercase text-sc-gray-dark">
            {{ $t('message.table.movementInfo.approvedBy') }}
          </b>
          <p class="text-sm text-sc-gray">
            {{ currentCheck && approvedBy || '-' }}
          </p>
        </div>
        <div class="pl-5 pr-10 md:col-span-2">
          <button
            @click="toggleModal"
            class="inline-block w-full py-3 text-sm leading-5 text-center text-white rounded hover:text-white focus:outline-none hover:bg-sc-blue-light bg-sc-blue"
          >
            {{ currentCheck ? $t('message.table.movementInfo.disapprove') : $t('message.table.movementInfo.approve') }}
          </button>
        </div>
      </div>
      <div
        class="col-span-1 col-start-2 pt-2 pb-3 md:col-start-3"
        v-if="extraColumnsNumber"
      >
        <div
          class="grid grid-cols-1"
          :style="{ height: `${extraColumnsHeight}px `}"
          :class="[`grid-rows-${extraColumnsRows}`, extraColumnsNumber && 'overflow-y-scroll']"
        >
          <div
            v-for="(extraColumn, index) in Object.values(extraColumnsSchema)"
            class="flex p-2 ml-3"
            :class="extraColumn.type !== 'Boolean'? 'flex-col' : ['flex-row-reverse',
                                                                  'flex-row self-start',
                                                                  'justify-end',
                                                                  'items-start']"
            :key="index"
          >
            <b class="text-xs uppercase text-sc-gray-dark">
              {{ extraColumn.name }}
            </b>
            <b-dropdown
              v-if="extraColumn.type === 'Enum'"
            >
              <b-tag
                type="is-primary"
                slot="trigger"
              >
                {{ extraColumns[extraColumn.name] }}
              </b-tag>
              <b-dropdown-item
                v-for="(tag, key) in extraColumn.options.tags"
                :key="key"
              >
                <button
                  @click="assignExtraColumnData(extraColumn.name, tag)"
                >
                  {{ tag }}
                </button>
              </b-dropdown-item>
            </b-dropdown>
            <div
              v-else-if="extraColumn.type === 'String'"
              class="flex"
            >
              <component
                :is="extraColumnsComponents[extraColumn.type].class"
                v-bind="extraColumnsComponents[extraColumn.type].props()"
                v-model="extraColumns[extraColumn.name]"
                @change.native="updateBankMovement"
                @focus="setActive(extraColumn.name)"
                @blur="clearActive()"
                @keyup.native.enter="loseFocus()"
                size="is-small"
                :class="extraColumnsComponents[extraColumn.type].style"
              />
              <button
                v-if="extraColumn.type=== 'String'"
                v-show="activeColumnName === extraColumn.name"
                class="-ml-10 text-sc-gray text-xs border border-sc-gray-light my-auto py0.5 px-1 rounded z-10"
              >
                {{ $t('message.table.movementInfo.enter') }}
              </button>
            </div>
            <div
              v-else
              class="flex"
            >
              <component
                :is="extraColumnsComponents[extraColumn.type].class"
                v-bind="extraColumnsComponents[extraColumn.type].props()"
                v-model="extraColumns[extraColumn.name]"
                @input="updateBankMovement"
                :date-formatter="dateFormatter"
                size="is-small"
                :class="extraColumnsComponents[extraColumn.type].style"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <confirmation-modal
      name="confirmationModalMovementInfo"
      ref="confirmationModalMovementInfo"
      :content="currentCheck ? $t('message.table.movementInfo.confirmPending') :
        $t('message.table.movementInfo.confirmApproved')"
      flip-buttons-style
      @confirmation="confirmAction"
      :is-approval-modal="!currentCheck"
    />
  </div>
</template>

<script>
import currency from '../../filters/currency.js';
import ConfirmationModal from '../confirmation-modal.vue';
import movementApi from '../../api/bank-movements.js';
import date from '../../filters/date';

export default {
  data() {
    return {
      activeColumnName: null,
      extraColumns: {},
      extraColumnsComponents: {
        'Boolean': { 'class': 'b-checkbox', 'props': () => ({}), 'style': '' },
        'Date': { 'class': 'b-datepicker', 'props': () => ({ 'position': 'is-bottom-right' }),
          'style': 'justify-center min-w-full sc-input px-2' },
        'String': { 'class': 'b-input', 'props': () => ({}),
          'style': 'justify-center min-w-full sc-input' },
      },
      translateStatus: {
        'pending': this.$t('message.table.status.pending'),
        'approved': this.$t('message.table.status.approved'),
      },
      extraColumnsUpdate: false,
      extraColumnsHeight: 0,
    };
  },
  components: {
    ConfirmationModal,
  },
  computed: {
    approvedBy() {
      return this.authorizerUser && this.authorizerUser.email;
    },
    authorizerUser() {
      return this.$store.state.users.authorizerUser;
    },
    comment() {
      return this.movementInfo && this.movementInfo.comment;
    },
    currentCheck() {
      return this.movementInfo && this.movementInfo.status === 'approved';
    },
    currentStatus() {
      return this.movementInfo && this.movementInfo.status;
    },
    description() {
      return this.movementInfo && this.movementInfo.description;
    },
    referenceId() {
      return this.movementInfo && this.movementInfo.referenceId;
    },
    formattedValue() {
      const formattedValue = this.movementInfo && currency(this.movementInfo.amount, this.movementInfo.currency);

      return formattedValue > 0 ? formattedValue : formattedValue.replace('-', '');
    },
    isIncome() {
      return this.movementInfo && this.movementInfo.amount > 0;
    },
    holderName() {
      return this.movementInfo && this.movementInfo.senderName;
    },
    holderRut() {
      return this.movementInfo && this.movementInfo.senderRut;
    },
    isAdmin() {
      return this.$store.state.users.isAdmin;
    },
    postDate() {
      return this.movementInfo && this.movementInfo.postDate;
    },
    transactionDate() {
      return this.movementInfo && this.movementInfo.transactionDate;
    },
    movementInfo() {
      return this.$store.state.movements.movement;
    },
    senderInfo() {
      if (this.movementInfo &&
          this.movementInfo.senderInstitution) {
        return `[${this.movementInfo.senderInstitution.name}] - ${this.movementInfo.senderNumber}`;
      }

      return null;
    },
    typeName() {
      return this.movementInfo && this.movementInfo.movementType === 'transfer' ? 'Transferencia' : 'Otro';
    },
    extraColumnsNumber() {
      const configuration = this.$store.state.entities.entityConfiguration;
      const extraColumnsSchemaArray = configuration && configuration.extraColumnsSchemaArray;
      if (!extraColumnsSchemaArray) return 0;

      return extraColumnsSchemaArray.length;
    },
    extraColumnsRows() {
      const defaultRowsNumber = 5;

      return Math.max(this.extraColumnsNumber, defaultRowsNumber);
    },
    extraColumnsSchema() {
      const configuration = this.$store.state.entities.entityConfiguration;
      const extraColumnsSchemaArray = configuration && configuration.extraColumnsSchemaArray;
      if (!extraColumnsSchemaArray) return {};
      const schema = {};
      extraColumnsSchemaArray.forEach((colSchema) => {
        schema[colSchema.name] = colSchema;
      });

      return schema;
    },
  },
  props: {
    entityId: {
      type: Number,
      required: true,
    },
    movementId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    confirmAction(content = '') {
      if (this.currentCheck) {
        this.removeCheck();
      } else {
        this.approveMovement(content);
      }
    },
    approveMovement(content = '') {
      this.$store.dispatch('approveMovement', { movementId: this.movementId, content });
    },
    removeCheck() {
      this.$store.dispatch('removeCheck', { movementId: this.movementId });
    },
    toggleModal() {
      this.$refs.confirmationModalMovementInfo.show();
    },
    assignExtraColumnData(name, data) {
      this.extraColumns[name] = data;
      this.updateBankMovement();
      this.$forceUpdate();
    },
    setActive(columnName) {
      this.activeColumnName = columnName;
    },
    clearActive() {
      this.setActive(null, null);
    },
    loseFocus() {
      document.activeElement.blur();
    },
    updateBankMovement() {
      const extraColumnsData = Object.entries(this.extraColumns).map((extraColumn) =>
        ({ 'name': extraColumn[0], 'value': extraColumn[1] }),
      );
      movementApi.updateExtraColumns({ extraColumns: extraColumnsData },
        { movementId: this.movementId, entityId: this.entityId },
      );
      this.extraColumnsUpdate = false;
    },
    hide() {
      this.$emit('close');
    },
    dateFormatter(dateValue) {
      const unixTime = dateValue.getTime();

      return unixTime ? date(dateValue) : '';
    },
  },
  mounted() {
    this.$store.dispatch('getMovement', this.movementId);
    const defaultColumnsGrid = this.$refs.defaultColumnsGrid;
    this.extraColumnsHeight = defaultColumnsGrid && defaultColumnsGrid.clientHeight;
  },
  watch: {
    movementInfo() {
      if (this.movementInfo) {
        Object.values(this.movementInfo.defaultedExtraColumns).forEach((extraColumn) => {
          let columnValue = extraColumn.value;
          if (this.extraColumnsSchema[extraColumn.name].type === 'Date') {
            columnValue = new Date(columnValue);
          }
          this.extraColumns[extraColumn.name] = columnValue;
        });
      }
    },
  },
};
</script>
<style lang="scss">
.sc-input {
  .is-small.input {
    @apply border-0 border-b-2 border-sc-gray-light shadow-none bg-transparent rounded-none p-0;
  }

  .is-small.input:focus {
    @apply border-sc-blue;
  }
}
</style>
